import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/Home.vue'
import UserPage from '../views/Layout.vue'

import { localStore, sessionStore } from '@/_utils/localstore'

Vue.use(Router)

export const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '',
      component: UserPage,
      children: [
        {
          path: '',
          name: '',
          component: Home,
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ '../views/Home.vue'),
        },
        {
          path: '/setting',
          name: 'setting',
          component: () => import(/* webpackChunkName: "setting" */ '../views/Setting.vue'),
        },
        // MANAGE
        {
          path: '',
          name: 'config',
          component: () => import(/* webpackChunkName: "config" */ '../views/User.vue'),
        },
        {
          path: 'category',
          name: 'category',
          component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
        },
        {
          path: 'user',
          name: 'user',
          component: () => import(/* webpackChunkName: "user" */ '../views/User.vue'),
        },
        {
          path: 'card',
          name: 'card',
          component: () => import(/* webpackChunkName: "card" */ '../views/Card.vue'),
        },
        {
          path: 'card-gateway',
          name: 'card_gateway',
          component: () => import(/* webpackChunkName: "card_gateway" */ '../views/CardGateway.vue'),
        },
        {
          path: 'beacon',
          name: 'beacon',
          component: () => import(/* webpackChunkName: "beacon" */ '../views/Beacon.vue'),
        },
        {
          path: 'beacon-carried',
          name: 'beacon_carried',
          component: () => import(/* webpackChunkName: "beacon_carried" */ '../views/BeaconCarried.vue'),
        },
        {
          path: 'floor',
          name: 'floor',
          component: () => import(/* webpackChunkName: "floor" */ '../views/Floor.vue'),
        },
        // VIEWER
        {
          path: 'user_search',
          name: 'user_search',
          component: () => import(/* webpackChunkName: "user_search" */ '../views/UserSearch.vue'),
        },
        {
          path: 'link',
          name: 'link',
          component: () => import(/* webpackChunkName: "link" */ '../views/Link.vue'),
        },
        {
          path: 'indoor/:user_id?',
          name: 'indoor',
          component: () => import(/* webpackChunkName: "indoor" */ '../views/Indoor.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'indoor_map',
            hyperCheck: true,
          },
        },
        {
          path: 'outdoor',
          name: 'outdoor',
          component: () => import(/* webpackChunkName: "outdoor" */ '../views/Outdoor.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'outdoor_map',
            hyperCheck: true,
          },
        },
        {
          path: 'outdoor/user/:user_id',
          name: 'outdoor_user',
          component: () => import(/* webpackChunkName: "outdoor_user" */ '../views/Outdoor.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'outdoor_map',
            hyperCheck: true,
          },
        },
        {
          path: 'outdoor/fixed-device/:fixed_id',
          name: 'outdoor_fixed_device',
          component: () => import(/* webpackChunkName: "outdoor_fixed_device" */ '../views/Outdoor.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'outdoor_map',
            hyperCheck: true,
          },
        },
        {
          path: 'outdoor/type/bound',
          name: 'outdoor_type_bound',
          component: () => import(/* webpackChunkName: "outdoor_type_bound" */ '../views/Outdoor.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'outdoor_map',
            hyperCheck: true,
          },
        },
        {
          path: 'workrecorder',
          name: 'workrecorder',
          component: () => import(/* webpackChunkName: "workrecorder" */ '../views/WorkRecorder.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'work_recorder',
          },
        },
        {
          path: 'timeline',
          name: 'timeline',
          component: () => import(/* webpackChunkName: "timeline" */ '../views/TimeLine.vue'),
        },
        {
          path: 'sanid',
          name: 'sanid',
          component: () => import(/* webpackChunkName: "sanid" */ '../views/SanID.vue'),
        },
        {
          path: 'geofence',
          name: 'geofence',
          component: () => import(/* webpackChunkName: "geofence" */ '../views/Geofences.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'geofence',
          },
        },
        {
          path: 'geofence-monitor/:geofence_id?',
          name: 'geofence_monitor',
          component: () => import(/* webpackChunkName: "geofence-monitor" */ '../views/GeofenceMonitor.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'geofence',
          },
        },
        {
          path: 'notification',
          name: 'notification',
          component: () => import(/* webpackChunkName: "notification" */ '../views/Notification.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'geofence',
          },
        },
        {
          path: 'notification-settings',
          name: 'notification_settings',
          component: () => import(/* webpackChunkName: "notification" */ '../views/NotificationSettings.vue'),
        },
        {
          path: '/stamp-rally',
          name: 'stamp_rally',
          component: () => import(/* webpackChunkName: "stamp_rally" */ '../views/StampRally.vue'),
          meta: {
            requirePermissionFeature: true,
            featureName: 'stamp_rally',
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    },
    { path: '*', redirect: '/dashboard' },
  ],
  linkActiveClass: 'is-active',
})

router.beforeEach((to: any, from: any, next: any): any => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStore.getItem('user')
  const prevPath = sessionStore.getItem('prevPath')

  // When the user expires and prepares to log out
  // Save the current URL to the session
  // And redirect to this URL when the user keeps logging in again.
  if (!authRequired && !prevPath) {
    sessionStore.setItem('prevPath', from.path)
  }

  if (authRequired && !loggedIn) {
    // User not login yet and want to redirect to url received
    sessionStore.setItem('prevPath', to.path)
    return next('/login')
  }

  if (publicPages.includes(from.path) && prevPath) {
    sessionStore.removeItem('prevPath')
    return next(prevPath)
  }

  next()
})
